// GENERATED FILE. Do not edit by hand.
// Source: laravel/app/Enums/ClubModule.php
// Regenerate with: php artisan club-modules:export
//
// Committed on purpose: frontend and backend deploy independently, so generating
// this at build time would not make it any fresher. Committing puts every change
// into the PR diff instead.

export const CLUB_MODULES = [
    'general',
    'ai',
    'messages',
    'feed',
    'members',
    'horses',
    'space-manager',
    'banking',
    'headless-api',
    'trainer-booking',
    'bookings',
    'tournaments',
    'journal',
    'training-planner',
    'tasks',
    'invoices',
    'shop',
    'kiosk',
    'access',
    'vouchers',
    'cms',
    'settings',
    'history'
] as const;

export type ClubModuleKey = (typeof CLUB_MODULES)[number];

/** Modules that can never be hidden: the emergency exit back to the settings. */
export const ALWAYS_VISIBLE_MODULES: readonly ClubModuleKey[] = [
    'general',
    'settings'
];

/** Release date per module, used to detect modules added since a profile was applied. */
export const CLUB_MODULES_SINCE: Record<ClubModuleKey, string> = {
    general: '2020-01-01',
    ai: '2020-01-01',
    messages: '2020-01-01',
    feed: '2020-01-01',
    members: '2020-01-01',
    horses: '2026-08-13',
    'space-manager': '2020-01-01',
    banking: '2026-08-12',
    'headless-api': '2020-01-01',
    'trainer-booking': '2020-01-01',
    bookings: '2020-01-01',
    tournaments: '2020-01-01',
    journal: '2020-01-01',
    'training-planner': '2026-08-19',
    tasks: '2026-08-13',
    invoices: '2020-01-01',
    shop: '2026-08-14',
    kiosk: '2026-10-14',
    access: '2020-01-01',
    vouchers: '2020-01-01',
    cms: '2026-09-10',
    settings: '2020-01-01',
    history: '2020-01-01'
};

/** Experimental feature flag required to see a module, null when generally available. */
export const CLUB_MODULES_EXPERIMENTAL: Record<ClubModuleKey, string | null> = {
    general: null,
    ai: null,
    messages: null,
    feed: null,
    members: null,
    horses: 'equestrian_v1',
    'space-manager': null,
    banking: null,
    'headless-api': 'headless_api',
    'trainer-booking': null,
    bookings: null,
    tournaments: 'turnaments',
    journal: null,
    'training-planner': null,
    tasks: null,
    invoices: null,
    shop: null,
    kiosk: null,
    access: null,
    vouchers: null,
    cms: null,
    settings: null,
    history: null
};
